/**
 * For maintainability we should separate controllers into their own modules
 */
angular.module('acme.view.application.passes.create.series.modals.remove.controllers', [
  'ui.bootstrap'
])

.controller('PassesCreateSeriesModalsRemoveController', ['$scope', '$uibModalInstance', 'type', 'name', function($scope, $uibModalInstance, type, name) {

    $scope.passesCreateSeriesModalsRemove = {

      model: {},

      init: function() {
        if (type) {
          this.model.type = type;
        }

        if (name) {
          this.model.name = name;
        }
      },

      confirm: function () {
        $uibModalInstance.close(true);
      },

      cancel: function () {
        $uibModalInstance.dismiss();
      },

      success: {
        init: function(response) {}
      },

      error: {
        init: function(response) {}
      }

    };

    $scope.passesCreateSeriesModalsRemove.init();

}]);